/** Boylam, enlem (derece; GeoJSON sırası). */
export type LonLat = readonly [lon: number, lat: number];

/** Yerkürenin ortalama yarıçapı, deniz mili (6371.0088 km / 1.852). */
export const EARTH_RADIUS_NM = 6371.0088 / 1.852;

const RAD = Math.PI / 180;

/** İki nokta arasındaki büyük daire mesafesi (haversine), deniz mili. */
export function haversineNm(a: LonLat, b: LonLat): number {
  if (a[0] === b[0] && a[1] === b[1]) return 0;
  const dLat = (b[1] - a[1]) * RAD;
  const dLon = (b[0] - a[0]) * RAD;
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(a[1] * RAD) * Math.cos(b[1] * RAD) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_NM * Math.asin(Math.min(1, Math.sqrt(h)));
}

/** Boylam farkı −180…180 aralığına (antimeridyen). */
export function lonDelta(from: number, to: number): number {
  let d = to - from;
  while (d > 180) d -= 360;
  while (d < -180) d += 360;
  return d;
}
